interface SwiperControlsProps {
    uniqueId: string
    className?: string
    showNavigation?: boolean
    showPagination?: boolean
}

export const swiperNavigationOptions = {
    prevEl: '.swiper-navigation__button-prev',
    nextEl: '.swiper-navigation__button-next',
    disabledClass: 'swiper-navigation__button--disabled',
    lockClass: 'swiper-navigation__button--lock',
}

export const swiperPaginationOptions = {
    el: '.swiper-pagination',
    paginationDisabledClass: 'swiper-pagination--disabled',
    bulletClass: 'swiper-pagination__bullet',
    bulletActiveClass: 'swiper-pagination__bullet--active',
    lockClass: 'swiper-pagination--lock',
    clickable: true,
    bulletElement: 'button',
    dynamicBullets: true,
    dynamicMainBullets: 3,
}

const SwiperControls = ({
    uniqueId,
    className = '',
    showNavigation = true,
    showPagination = true,
}: SwiperControlsProps) => {
    const prevButtonClass = `swiper-navigation__button swiper-navigation__button-prev swiper-navigation__button-prev-${uniqueId}`
    const nextButtonClass = `swiper-navigation__button swiper-navigation__button-next swiper-navigation__button-next-${uniqueId}`
    const paginationClass = `swiper-pagination swiper-pagination-${uniqueId}`

    return (
        <div className={`swiper-controls ${className}`}>
            {showNavigation && <button className={prevButtonClass}></button>}
            {showPagination && <nav className={paginationClass}></nav>}
            {showNavigation && <button className={nextButtonClass}></button>}
        </div>
    )
}

export default SwiperControls
